import { EventBus, Events } from "jiffy-store";
import "./product-details-made-sample-cta.scss";

const $getSampleLinks = () => document.querySelectorAll(".js-made-sample-cta-link");
const $getSampleToggler = () => document.querySelector(".js-made-sample-cta-toggler");
const $getProductPageContainer = () => document.getElementById("product-page-container");

const getProductInfo = () => {
  const $container = $getProductPageContainer();
  if (!$container) return null;

  // Get product ID from data-real-product-id attribute
  const productId = $container.dataset.realProductId;

  // Get product slug from data-product-id attribute
  const productSlug = $container.dataset.productId;

  // Get composition from data-composition-name attribute or URL parameter
  const composition =
    $container.dataset.compositionName ||
    new URLSearchParams(window.location.search).get("ac") ||
    "White";

  return { productId, productSlug, composition };
};

// Removed unused function buildDesignLabUrl

const createFormInput = (name, value) => {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = name;
  input.value = value;
  return input;
};

const initSampleToggler = () => {
  const $sampleToggler = $getSampleToggler();
  if (!$sampleToggler) return;

  // Prevent default link behavior and build dynamic URL
  $sampleToggler.addEventListener("click", e => {
    e.preventDefault();

    const productInfo = getProductInfo();
    if (!productInfo) return;

    // Create a form and submit it to design-lab/start
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/design-lab/start";
    form.style.display = "none";

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrfToken) {
      form.appendChild(createFormInput("authenticity_token", csrfToken));
    }

    // Add form inputs
    form.appendChild(createFormInput("product_id", productInfo.productId));
    form.appendChild(createFormInput("composition_name", productInfo.composition));
    form.appendChild(createFormInput("sample", "true"));

    document.body.appendChild(form);
    form.submit();
  });
};

const updateDataAttributes = color => {
  const $sampleLinks = $getSampleLinks();
  const $container = $getProductPageContainer();

  // Update all sample links
  $sampleLinks.forEach($link => {
    const url = new URL($link.href);
    url.searchParams.set("ac", color);
    // eslint-disable-next-line no-param-reassign
    $link.href = url.pathname + url.search;
  });

  // Update the data-composition-name attribute on the product page container
  if ($container) {
    $container.dataset.compositionName = color;
  }
};

const initChangeColorHandler = () => {
  // Handle color changes from slider
  EventBus.on(Events.PRODUCT_COLOR_SELECTED_FROM_SLIDER, (e, { color }) => {
    updateDataAttributes(color);
  });

  // Handle color changes from modal
  EventBus.on(Events.PRODUCT_COLOR_SELECTED, (e, { color }) => {
    updateDataAttributes(color);
  });
};

export default () => {
  initSampleToggler();
  initChangeColorHandler();
};
